<template>
  <div class="ShadeBox" @mousewheel="mousewheel">
    <div class="maskLayer"></div>
    <div class="betaToast intro-x">
      <div class="toastTitle">支付密码设置</div>

      <div class="formDataClass">
        <div class="formNameclass">
          <p class="p1">输入新密码</p>
          <p class="p2">
            <el-input
              v-model="info.newPasscode"
              placeholder="输入新密码"
              show-password
              clearable
            ></el-input>
          </p>
          <p class="p1">手机号码</p>
          <p class="p2">
            <!--                        <el-input v-model="acc_alipay" placeholder="输入手机号码" clearable>-->
            <el-input
              v-model="phone"
              placeholder="输入手机号码"
              :disabled="true"
              clearable
            >
            </el-input>
          </p>
          <p class="p1">输入验证码</p>
          <div class="p3">
            <el-input v-model="info.code" placeholder="输入验证码" clearable>
            </el-input>
            <el-button type="primary" @click="sendMobile">{{
              btnMsg == null ? countNum + "s后重新发送" : btnMsg
            }}</el-button>
          </div>
        </div>
      </div>

      <div class="buttom-p">
        <span class="span1" @click="setCancel">取消</span>
        <span class="span2" @click="btnWechat">确认</span>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";

import lodash from "lodash";

export default {
  props: {
    infoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 手机号
      acc_alipay: "",
      // 倒计时周期
      countNum: 60,
      // 用于倒计时标记，true-正在倒计时
      countFlag: false,
      // 定时器
      intervalBtn: {},
      //默认按钮的值
      btnMsg: "发送验证码",
      info: {
        phone: "",
        input: "",
        newPasscode: "",
        psw2: "",
        Label: false,
        phone_input: false,
        code: "",
      },
    };
  },
  created() {
    // console.log(this.infoData.passcode)
    this.phone = this.infoData.phone;
  },
  methods: {
    // 倒计时
    countDown() {
      // 设置btn倒计时时显示的信息
      this.btnMsg = null;
      // 更改btn状态
      this.countFlag = !this.countFlag;
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if (this.countNum <= 0) {
          // 重置btn提示信息
          this.btnMsg = "发送验证码";
          // 清除定时器
          clearInterval(this.intervalBtn);
          // 更改btn状态
          this.countFlag = !this.countFlag;
          // 重置倒计时状态
          this.countNum = 60;
        }
        // 倒计时
        this.countNum--;
      }, 1000);
    },
    // 获取验证码 --- > 防抖
    sendMobile: lodash.debounce(function () {
      if (this.btnMsg == null) {
        return;
      }

      // //获取输入手机号码
      // let phone = this.phone;
      // //正则校验手机号是否合法
      // if (!/^1(3|4|5|7|8)\d{9}$/.test(phone)) {
      //     this.$message.error("手机号错误");
      //     return;
      // }
      this.countDown();

      request({
        url: "/api/sign/sms",
        method: "POST",
        data: {
          phone: this.phone,
        },
      }).then((res) => {
        //触发定时器方法
        this.info.phone_input = true;
      });
    }),
    // 提交
    btnWechat: function () {
      const reg = /^([A-Za-z0-9]{6,18})|([\u4e00-\u9fa5]{2,10})|([\u4e00-\u9fa5][\w\W]{2})$/;
      let newPasscode = this.info.newPasscode;
      if (!reg.test(newPasscode)) {
        this.$message.error("请输入6-18位任意字符");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      request({
        url: "/api/profile/save/passcode",
        method: "POST",
        data: {
          passcode: newPasscode,
          phone: this.phone,
          captcha: this.info.code,
        },
      })
        .then((res) => {
          this.$message.success("设置成功！");
          // console.log(newPasscode)
          // console.log(this.phone)
          this.$emit("setCancel", "zfPassword", true); // 控制弹窗关闭
          loading.close();
        })
        .catch((err) => {
          loading.close();
          this.$emit("setCancel", "zfPassword", false); // 控制弹窗关闭
        });
    },
    // 取消
    setCancel: function () {
      this.$emit("setCancel", "zfPassword"); // 控制弹窗关闭
    },

    //  遮罩层防滚动穿透
    mousewheel: function (e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.ShadeBox {
  width: 100vw;
  height: 100vw;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .maskLayer {
    width: 100vw;
    height: 100vh;
    background: #000000;
    opacity: 0.7;
  }
  .betaToast {
    width: 23vw;
    min-width: 21rem;
    height: 440px;
    background: #ffffff;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 22px;
    overflow: hidden;
    box-sizing: border-box;
    .toastTitle {
      border-bottom: 1px solid #f4f4f4;
      padding: 20px;
      font-size: 16px;
      color: #333333;
      box-sizing: border-box;
    }
  }
}
.formDataClass {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  .formNameclass {
    width: 100%;
    box-sizing: border-box;

    .p1 {
      height: 47px;
      line-height: 50px;
      font-size: 14px;
      color: #333333;
    }
    .p3 {
      display: flex;
      justify-content: space-between;
      .el-input {
        margin-right: 5px;
      }
      .el-button {
        border-radius: 15px;
      }
    }
  }
}

.buttom-p {
  width: 100%;
  border-top: 1px solid #f4f4f4;
  margin-top: 30px;
  text-align: right;
  padding: 20px;
  box-sizing: border-box;

  span {
    display: inline-block;
    padding: 10px 25px;
    margin-left: 4px;
    vertical-align: middle;
    box-sizing: border-box;
    border-radius: 6px;
  }
  .span1 {
    border: 1px solid #e2e8f0;
  }

  .span2 {
    color: #fff;
    background: #1890ff;
  }

  .span2:active {
    background: #2d9aff;
  }

  .span1:active {
    background: #e9e9e9;
  }
}
</style>